module.exports = __webpack_public_path__ + "img/3545 Consulting Logo - Transparent.828dbc6f.png";